import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import i18n from "src/common/i18n";
import { IAppReduxState, IMyOpenTasks } from "src/common/types";
import { DEFAULT_LOCALE } from "src/config";

const mapStateToProps = ({ currentUser: { openTasks } }: IAppReduxState): IMyOpenTasks => openTasks;

const RedirectByContext = ({ myEmployeesCount, myFeedbacksCount }: IMyOpenTasks) => {
  /*
    The selection of the language has to be moved here. Otherwise,
    every time the home button is clicked (logo) the correct language
    is not reflected correctly in the url.
  */
  let lng = DEFAULT_LOCALE;
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  if (selectedLanguage) {
    lng = selectedLanguage;
    i18n.changeLanguage(lng);
  }

  const redirectUrl =
    myEmployeesCount && !myFeedbacksCount ? `/${lng}/dashboard/my-employees` : `/${lng}/dashboard/my-feedbacks`;

  return <Redirect to={redirectUrl} />;
};

export default connect(mapStateToProps)(RedirectByContext);
